import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WorkflowDemo } from '../models/workflow-demo.model';

@Injectable({
  providedIn: 'root'
})
export class WorkflowDemosService {
  private readonly dataUrl = 'assets/data/workflow-demos.json';

  constructor(private readonly http: HttpClient) {}

  getWorkflowDemos(): Observable<WorkflowDemo[]> {
    return this.http.get<WorkflowDemo[]>(this.dataUrl);
  }
}
